import React, { useState, useEffect } from 'react';
import './AddressSearch.css'; // Create a CSS file for your custom styles
import { url } from '../utils/baseurl';
const AddressSearch = () => {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [alertinfo, setAlertInfo] = useState('');
  const [opn, setOpn] = useState(true);
  const [infoOpen, setInfoOpen] = useState(false);
  const [isloading, setisloading] = useState(false)

  useEffect(() => {
    if (inputValue.length > 0) {
      fetchSuggestions();
    } else {
      setSuggestions([]);
    }
  }, [inputValue]);

  const fetchSuggestions = () => {
    const mapboxAccessToken = 'pk.eyJ1IjoicHJhdGhhbTcwNCIsImEiOiJjbG1xaDJrdzEwNHVpMnFwaXloODIwc2Q0In0.M-0gUqeNHe6A9Z7LeaVFVw'; // Replace with your Mapbox access token

    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${inputValue}.json?country=IN&access_token=${mapboxAccessToken}`
    )
      .then((response) => response.json())
      .then((data) => {
        setSuggestions(data.features.map((feature) => feature.place_name));
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value.trim());
    setOpn(true);
    setAlertInfo(null);
    setInfoOpen(false);
  };

  function convertToURLFormat(cityName) {
    // Replace spaces with "+"
    cityName = cityName.replace(/ /g, '+');

    // Add "+" between letters if there are spaces between them
    cityName = cityName.replace(/(\s+)/g, '+');

    return cityName;
  }

  async function fetchdet(cityname) {

    setisloading(true)
    const formattedCityName = convertToURLFormat(cityname);
    console.log(formattedCityName);

    const response = await fetch(
      `${url}/FetchAddressWiseAlerts?address=${formattedCityName}&radius=20`
    );
    const data = await response.json();

    if (data.alerts.length > 0) {
      setAlertInfo(data.alerts);
      setInfoOpen(true);
      setisloading(false);
    } else {
      setInfoOpen(true);
      setAlertInfo(null);
      setisloading(false);

    }

    console.log(data.alerts.length);
    console.log(data.alerts);
  }

  return (
    <>
   <div className="address-search-container">
        <input
          type="text"
          id="cityInput"
          placeholder="Search by City name or Address" 
          className="input-box shadow-md p-2 rounded-md sm:w-full md:w-[600px] lg:w-[600px]" // Responsive widths
          value={inputValue}
          onChange={handleInputChange}
        />

        {opn ? (
          <ul id="suggestions" className="suggestions-box absolute bg-white rounded-md shadow-md sm:w-full md:w-[300px] lg:w-[400px]"> {/* Responsive widths */}
            {suggestions.map((cityName, index) => (
              <li
                key={index}
                className="suggestion-item p-2 cursor-pointer hover:bg-gray-100"
                onClick={() => {
                  setInputValue(cityName);
                  fetchdet(cityName);
                  setOpn(false);
                }}
              >
                {cityName}
              </li>
            ))}
          </ul>
        ) : (
          <></>
        )}
      </div>



      {isloading?<>
      
        <div className="info-box bg-gray-200 p-4 rounded-md shadow-md mt-4 sm:w-[200px] md:w-[300px] lg:w-[400px]"> {/* Responsive widths */}
          <p>FETCHING DETAILS ...........</p>
        </div>
      
      
      
      
      </>:
      
      
      
      
      
      
      <>
      
      
      
      {infoOpen ? (
        <>
          {alertinfo ? (
           <div className={`info-box p-4 rounded-md shadow-lg mt-4 sm:w-[200px] md:w-[300px] lg:w-[400px] ${alertinfo[0]?.severity_color}-bg`}>
           <h4 className={`text-${alertinfo[0]?.severity_color}-800 font-semibold text-lg mb-2`}>ALERT FOUND</h4>
           <div className="mb-4">
             <div className="mb-2">
               <p className="text-gray-800 font-semibold">Area:</p>
               <p className={`text-${alertinfo[0]?.severity_color}-800`}>{alertinfo[0]?.area_description}</p>
             </div>
             <div className="mb-2">
               <p className="text-gray-800 font-semibold">Disaster Type:</p>
               <p className={`text-${alertinfo[0]?.severity_color}-800`}>{alertinfo[0]?.disaster_type}</p>
             </div>
             <div className="mb-2">
               <p className="text-gray-800 font-semibold">Severity:</p>
               <p className={`text-${alertinfo[0]?.severity_color}-800 font-semibold`}>
                 {alertinfo[0]?.severity_color === "yellow" ? (
                   <span className="text-yellow-600">LOW</span>
                 ) : alertinfo[0]?.severity_color === "red" ? (
                   <span className="text-red-600">HIGH</span>
                 ) : (
                   <span className="text-orange-600">MEDIUM</span>
                 )}
               </p>
             </div>
             <div className="mb-2">
               <p className="text-gray-800 font-semibold">Warning:</p>
               <p className={`text-${alertinfo[0]?.severity_color}-800`}>{alertinfo[0]?.warning_message}</p>
             </div>
             <div className="mb-2">
               <p className="text-gray-800 font-semibold">Start Time:</p>
               <p className={`text-${alertinfo[0]?.severity_color}-800`}>{alertinfo[0]?.effective_start_time}</p>
             </div>
             <div>
               <p className="text-gray-800 font-semibold">End Time:</p>
               <p className={`text-${alertinfo[0]?.severity_color}-800`}>{alertinfo[0]?.effective_end_time}</p>
             </div>
           </div>
         </div>
         
          ) : (
            <div className="info-box bg-blue-100 p-4 rounded-md shadow-md mt-4 sm:w-[200px] md:w-[300px] lg:w-[400px]">
            <p>Alert not found for {inputValue} region</p>
          </div>
          
          )}
        </>
      ) : (

        <></>
      
      )}
      
      
      
      
      
      
      
      
      </>}

 
    </>
  );
};

export default AddressSearch;
